import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { refreshAppOnHome } from "../serviceWorkerRegistration";

/** Kiosk attract screen at "/" — the CTA opens sign-in (/login). */
function Welcome() {
  const navigate = useNavigate();

  useEffect(() => {
    void refreshAppOnHome();
  }, []);

  return (
    <div className="welcomePage">
      <div className="welcomePage__content">
        <h1 className="welcomePage__title">Check My Gallery</h1>
        <button
          type="button"
          className="welcomePage__cta"
          onClick={() => navigate("/login")}
        >
          Tap to get started
        </button>
      </div>
    </div>
  );
}

export default Welcome;
